var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "only-number",
      rawName: "v-only-number"
    }],
    attrs: {
      "label": "Ano Letivo",
      "outlined": "",
      "dense": "",
      "maxlength": "4",
      "hide-details": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarAnosLetivos.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.ano,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ano", $$v);
      },
      expression: "form.filters.ano"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "only-number",
      rawName: "v-only-number"
    }],
    attrs: {
      "label": "Duração (semanas)",
      "outlined": "",
      "maxlength": "3",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarAnosLetivos.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.duracao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "duracao", $$v);
      },
      expression: "form.filters.duracao"
    }
  })], 1), _c('sca-select-ativo', {
    attrs: {
      "cols": 3,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-0"
  }, [_c('sca-date-picker', {
    attrs: {
      "cols": 3,
      "label": "Data de Início",
      "outlined": "",
      "dense": "",
      "allowedDates": _vm.anoAtualOuMaior,
      "rules": [_vm.dataInicioMenorQueFim]
    },
    model: {
      value: _vm.form.filters.dataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicio", $$v);
      },
      expression: "form.filters.dataInicio"
    }
  }), _c('sca-date-picker', {
    attrs: {
      "cols": 3,
      "label": "Data de Término",
      "outlined": "",
      "dense": "",
      "allowedDates": _vm.anoAtualOuMaior,
      "rules": [_vm.dataInicioMenorQueFim]
    },
    model: {
      value: _vm.form.filters.dataFim,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFim", $$v);
      },
      expression: "form.filters.dataFim"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarAnosLetivos();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterAnoLetivo();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "no-data-text": _vm.noDataText
    },
    scopedSlots: _vm._u([{
      key: `item.dataInicio`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('span', [_vm._v(_vm._s(_vm._f("date")(item.dataInicio)))])];
      }
    }, {
      key: `item.dataFim`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('span', [_vm._v(_vm._s(_vm._f("date")(item.dataFim)))])];
      }
    }, {
      key: `item.situacao`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.ativo,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sca-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarAnoLetivo(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterAnoLetivo(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": `${item.situacao ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.situacao ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarAnoLetivo(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarAnoLetivoDialog', {
    attrs: {
      "visible": _vm.dialogManterAnoLetivo.visible,
      "content": _vm.dialogManterAnoLetivo.content,
      "edit": _vm.dialogManterAnoLetivo.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterAnoLetivo.close();
      },
      "onSave": function ($event) {
        return _vm.buscarAnosLetivos();
      }
    }
  }), _vm.dialogVisualizarAnoLetivo.visible ? _c('VisualizarAnoLetivoDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarAnoLetivo.visible,
      "content": _vm.dialogVisualizarAnoLetivo.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarAnoLetivo.close();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }